import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ROUTES from 'src/constants/routes'
import { useGetAnimalById } from 'src/hooks/api/animal'
import { useGetPregnancyDiagnosisById, useUpdatePregnancyDiagnosis } from 'src/hooks/api/pregnancy-diagnosis'
import { useUpdateCoverageProcess } from 'src/hooks/api/coverage-process'
import { useSaveDiagnosisComplete } from 'src/hooks/api/pregnancy-diagnosis'
import { CoverageProcessParams, PregnancyDiagnosisParams } from 'src/domain/coverage-process'
import { isTodayOutsideForecast } from '../../utils/functions'
import { toast } from 'react-toastify'
import { toastSyncSuccess } from 'src/utils/syncToast'

export const useBreedingListDetails = () => {
  const navigate = useNavigate()

  const [searchParams, setSearchParams] = useSearchParams()
  const idAnimal = searchParams.get('idAnimal')
  const idDiagGest = searchParams.get('idDiagGest')
  const openDiagnosisParam = searchParams.get('openDiagnosis')

  const [isDiagnosisPopupOpen, setIsDiagnosisPopupOpen] = useState(false)
  const [showBirthWarningModal, setShowBirthWarningModal] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)

  // Abre o modal de confirmação de delete
  const handleOpenDeleteModal = () => {
    setIsDeleteModalOpen(true)
  }

  // Fecha o modal de confirmação de delete
  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false)
  }

  // Confirma a exclusão lógica
  const handleConfirmDelete = async () => {
    if (!pregnancyDiagnosis) return
    try {
      await updatePregnancyDiagnosis({
        ...pregnancyDiagnosis,
        acao: 'Removido'
      } as PregnancyDiagnosisParams)

      toastSyncSuccess('Reprodução removida com sucesso!')
      navigate(ROUTES.REPRODUCTION.PREGNANCY_LIST)
    } catch (error) {
      toast.error('Erro ao remover reprodução')
    }
    setIsDeleteModalOpen(false)
  }

  const { mutateAsync: updateCoverageProcess } = useUpdateCoverageProcess()
  const { mutateAsync: updatePregnancyDiagnosis, isPending: isUpdatingCoverageProcess } = useUpdatePregnancyDiagnosis()

  const { mutateAsync: saveDiagnosisComplete, isPending: isSavingDiagnosis } = useSaveDiagnosisComplete()

  const handleSave = async (payload?: CoverageProcessParams) => {
    if (!payload) return
    await updateCoverageProcess(payload)
  }

  const handleOpenDiagnosisModal = (diagnosisDate?: string, reproductionDate?: string) => {
    if (isTodayOutsideForecast(diagnosisDate, reproductionDate)) {
      setShowBirthWarningModal(true)
      return
    }
    setIsDiagnosisPopupOpen(true)
  }

  const handleConfirmOpenDiagnosisModal = () => {
    setShowBirthWarningModal(false)
    setIsDiagnosisPopupOpen(true)
  }

  const handleSaveDiagnosis = async (payload?: PregnancyDiagnosisParams | any) => {
    if (!payload) return

    await saveDiagnosisComplete({
      diagnosis: payload,
      updateProcess: false,
      motherData: cowMother
        ? {
            idLoteAtual: cowMother.idLoteAtual,
            idPastoAtual: cowMother.idPastoAtual,
            nome: cowMother.nome
          }
        : undefined
    })
    setIsDiagnosisPopupOpen(false)
  }

  const breedingId = idAnimal && idDiagGest ? `#${idAnimal}/${idDiagGest}` : undefined

  const {
    data: pregnancyDiagnosis,
    isLoading: isLoadingPregnancyDiagnosis,
    isError,
    error
  } = useGetPregnancyDiagnosisById(breedingId!)
  const { data: cowMother, isLoading: isLoadingCow } = useGetAnimalById(pregnancyDiagnosis?.idAnimal!)
  const { data: bullFather, isLoading: isLoadingBull } = useGetAnimalById(pregnancyDiagnosis?.touro!)

  useEffect(() => {
    if (openDiagnosisParam === 'true' && pregnancyDiagnosis && !isLoadingPregnancyDiagnosis) {
      setIsDiagnosisPopupOpen(true)
      searchParams.delete('openDiagnosis')
      setSearchParams(searchParams, { replace: true })
    }
  }, [openDiagnosisParam, pregnancyDiagnosis, isLoadingPregnancyDiagnosis])

  const handleSaveDiagnosisCompleteWithMother = async (params: any) => {
    return await saveDiagnosisComplete({
      ...params,
      motherData: cowMother
        ? {
            idLoteAtual: cowMother.idLoteAtual,
            idPastoAtual: cowMother.idPastoAtual,
            nome: cowMother.nome
          }
        : undefined
    })
  }

  return {
    isLoading: isLoadingPregnancyDiagnosis || isLoadingCow || isLoadingBull,
    isUpdatingCoverageProcess: isUpdatingCoverageProcess,
    error: error as any,
    isError: isError,
    isSavingDiagnosis,
    pregnancyDiagnosis,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleConfirmDelete,
    handleSave,
    handleOpenDiagnosisModal,
    handleConfirmOpenDiagnosisModal,
    handleSaveDiagnosis,
    handleSaveDiagnosisComplete: handleSaveDiagnosisCompleteWithMother,
    isDiagnosisPopupOpen,
    setIsDiagnosisPopupOpen,
    showBirthWarningModal,
    setShowBirthWarningModal,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    cowMother,
    bullFather
  }
}
